<template>
  <div>

    <vx-card class="mb-wide">

      <!--    제목-->
      <vs-row class="read-layout">
        <vs-col class="read-layout-title">제목</vs-col>
        <vs-col>
          <vs-input class="w-full" v-model="form.postTitle" @keyup.enter="form.postTitle = ''"
                    placeholder="Title"></vs-input>
        </vs-col>
      </vs-row>

      <!--    작성자-->
      <vs-row class="read-layout-2">
        <vs-col class="read-layout-title">작성자</vs-col>
        <vs-col class="mr-8">
          <span v-if="post.author" class="text-sm">{{post.author.username}}</span>
          <span v-else class="text-sm">비회원</span>
        </vs-col>
        <vs-col class="read-layout-title">작성일</vs-col>
        <vs-col>
          <span class="text-sm">{{ post.created_at }}</span>
        </vs-col>
      </vs-row>

      <!--    구분선 -->
      <vs-divider></vs-divider>

      <!--    내용-->
      <vs-row class="read-layout">
        <vs-col class="read-layout-title top">내용</vs-col>
        <vs-col>
          <quill-editor class="ql-edit-text" v-model="form.postContent" :options="quillOption"></quill-editor>
        </vs-col>
      </vs-row>

      <!--    구분선 -->
      <vs-divider></vs-divider>


      <!--    첨부파일-->
      <vs-row class="read-layout">
        <vs-col class="read-layout-title top">첨부파일</vs-col>
        <vs-col>
          <vs-upload ref="vs_upload" class="fix-vs-upload" :action="fileUpLoadAction"
                     :headers="fileUpLoadHeaders" @change="handleChangeFile" @on-success="handleSuccessFileUpload" @on-delete="handleDeleteFile"
                     automatic file-name="file_data" :show-upload-button="false" limit="5"></vs-upload>
        </vs-col>
      </vs-row>

    </vx-card>

    <vs-row class="mb-wide">
      <vs-col class="vs-button-list-right">
        <vs-button class="mr-2" color="secondary" @click="handleClickUpdate">저장</vs-button>
        <vs-button @click="handleClickCancel" type="border">취소</vs-button>
      </vs-col>
    </vs-row>

  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {quillEditor} from 'vue-quill-editor'
import FileInput from '@/components/custom/FileInput'

export default {
  name: 'TemplateUpdateNormal',
  components: {
    FileInput,
    quillEditor
  },

  props: {
    isAuthor: { type: Boolean, default: false },

    post: Object,
    prevPost: Object, // prevPost = {title, postId}
    nextPost: Object, // nextPost = {title, postId}

    // 파일 업로드 URL
    fileUpLoadHeaders: Object,
    fileUpLoadAction: String
  },

  data () {
    return {
      oldFileIds: [],
      form: {
        postTitle:'',
        postContent:''
      },
      quillOption: {
        placeholder: '내용을 입력해주세요 ...'
      }
    }
  },

  watch: {
    post () {
      const attachment = this.post.post_attachment
      for (let i = 0; i < attachment.length; i++) {
        this.oldFileIds.push({
          id:attachment[i].id,
          path:attachment[i].path
        })
        this.setVsUploadImage(this, attachment[i].path)
      }

      this.form.postTitle = this.post.post_title
      this.form.postContent = this.post.post_content
    }
  },

  methods: {

    // vs-upload에 초기 이미지 넣기
    setVsUploadImage (_t, src) {
      let orientation = 'h'
      const image = new Image()
      image.src = src
      image.onload = function () {
        if (this.width > this.height) {
          orientation = 'w'
        }
        _t.$refs.vs_upload.srcs.push({
          src: this.src,
          orientation,
          type: 'image',
          percent: null,
          error: false,
          remove: false
        })
        _t.$refs.vs_upload.filesx.push({
          src: this.src,
          orientation,
          type: 'image',
          percent: null,
          error: false,
          remove: false
        })
      }
    },

    handleChangeFile (path, files) {
      this.$emit('handleChangeFile', path, files)
    },
    handleSuccessFileUpload (event) {
      // response
      let response = event.currentTarget.response
      response = JSON.parse(response)
      const uploadedFileID = response.id
      this.$emit('handleSuccessFileUpload', uploadedFileID)
    },
    handleDeleteFile (file) {
      // vs-upload 컴포넌트에 초기 이미지를 넣는 기능을 제공하지 않아,
      // setVsUploadImage 함수를 별도로 제작하여 강제로 이미지를 추가.
      // 이후, 삭제시 강제로 추가한 이미지에 대해서는 File 형식으로 나오지 않기 때문에 구분하여 처리
      if (file instanceof File) {
        this.$emit('handleDeleteNewFile', file)
      } else {
        for (const oldFile of this.oldFileIds) {
          if (oldFile.path === file.src) {
            this.$emit('handleDeleteOldFile', oldFile.id)
            break
          }
        }
      }
    },
    handleClickUpdate () {
      const title = this.form.postTitle
      const content = this.form.postContent
      this.$emit('handleClickUpdate', title, content)
    },
    handleClickCancel () {
      this.$emit('handleClickCancel')
    }
  }
}
</script>

<style scoped>
.content-head {
  width: 100px;
  font-weight: bold;
}

.content-read {
  min-height: 20em;
  line-height: 1.6;
}

.read-layout,
.read-layout-2 {
  margin-bottom:1.5rem;
}

.read-layout {
  display: grid !important;
  grid-template-columns: 60px 1fr;
}
.read-layout-2 {
  display: grid !important;
  grid-template-columns: 60px auto 60px 1fr;
}
.read-layout-title {
  font-weight: bold;
  display: flex;
  align-items: center;
}
.read-layout-title.top{
  align-items: start;
}

.read-layout-footer .read-layout-title{
  height:100%;
  justify-content: center;

  background-color: #EDEDED;
}
.read-layout-footer span {
  height:100%;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.add-comment .vs-row {
  display: grid !important;
  margin-right:-1.5rem;
  grid-template-columns: minmax(0%, 100%) 12rem;
}

.mb-wide { margin-bottom:1.5rem !important;}
.vs-button-list-right { width:auto !important; margin-left:auto !important;}
</style>

<style>
.ql-edit-text .ql-editor {
  overflow-y: scroll;
  resize: vertical;
  min-height: 20em;
}

.read-vs-upload .btn-x-file {
  visibility: hidden;
}

.add-comment .vx-card__collapsible-content .vx-card__body {
  padding-right:0px !important;
}

.col-img .vs-image--img{
  background-color: #C4C4C4 !important;
}
</style>
